var constants = require('../constants');
var initialState = require('../../initialState');

var messageReducer = function(state, action) {
    var newstate = Object.assign({}, state);

    newstate.messageData = newstate.messageData || {};
    newstate.messageData.subject = newstate.messageData.subject || {};
    newstate.messageData.tags = newstate.messageData.tags || [];
    newstate.messageData.action = newstate.messageData.action || {};
    newstate.messageData.meta = newstate.messageData.meta || {};
    newstate.messageData.meta.target = newstate.messageData.meta.target || [];
    newstate.messageData.meta.notification = newstate.messageData.meta.notification || {};

    switch (action.type) {
        case constants.REQUEST_MESSAGE:
            newstate.isFetching = true;
            return newstate;
        case constants.RECEIVE_MESSAGE:
            newstate.isFetching = false;
            newstate.messageData = action.data.message;
            return newstate;
        case constants.REQUEST_MESSAGE_FAILURE:
            newstate.isFetching = false;
            newstate.error = action.errors;
            return newstate;

        case constants.SET_MESSAGE:
            newstate.messageData = action.message;
            return newstate;
        case constants.CLEAR_MESSAGE:
            newstate.messageData = {
                subject: {},
                tags: [],
                action: {},
                meta: {
                    target: []
                }
            };
            return newstate;

        case constants.CHANGE_SUBJECT_TEXT:
            newstate.messageData.subject.text = action.subjectText;
            return newstate;
        case constants.CHANGE_SUBJECT_IMAGE:
            newstate.messageData.subject.image = action.subjectImage;
            return newstate;
        case constants.CHANGE_TITLE:
            newstate.messageData.title = action.title;
            return newstate;
        case constants.ADD_TAG:
            newstate.messageData.tags = action.tagIDs;
            return newstate;
        case constants.REMOVE_TAG:
            newstate.messageData.tags = action.tagIDs;
            return newstate;
        case constants.CHANGE_TEXT:
            newstate.messageData.text = action.text;
            return newstate;
        case constants.CHANGE_ACTION_IMAGE:
            newstate.messageData.action.image = action.actionImage;
            return newstate;
        case constants.CHANGE_ACTION_TARGET:
            newstate.messageData.action.target = action.actionTarget;
            return newstate;
        case constants.ADD_TARGET:
            newstate.messageData.meta.target = action.targetIDs;
            return newstate;
        case constants.REMOVE_TARGET:
            newstate.messageData.meta.target = action.targetIDs;
            return newstate;
        case constants.CHANGE_TARGET:
            newstate.messageData.meta.target = action.targetIDs;
            return newstate;
        case constants.CHANGE_SEND_PUSH:
            newstate.messageData.meta.sendPush = !!action.sendPush;
            newstate.messageData.meta.sendNotification = newstate.messageData.meta.sendPush;
            return newstate;
        case constants.CHANGE_PUSH_TEXT:
            newstate.messageData.meta.pushText = action.pushText;
            newstate.messageData.meta.notification.text = newstate.messageData.meta.pushText;
            return newstate;
        case constants.CHANGE_PUSH_LINK:
            newstate.messageData.meta.pushLink = action.pushLink;
            newstate.messageData.meta.notification.deepLink = newstate.messageData.meta.pushLink;
            return newstate;

        case constants.MESSAGE_CREATE_REQUEST:
            newstate.isFetching = true;
            return newstate;
        case constants.MESSAGE_CREATE_SUCCESS:
            newstate.isFetching = false;
            // newstate.messageData = action.data.message;
            newstate.error = {};
            return newstate;
        case constants.MESSAGE_CREATE_FAILURE:
            newstate.isFetching = false;
            newstate.error = action.errors;
            return newstate;

        case constants.MESSAGE_EDIT_REQUEST:
            newstate.isFetching = true;
            return newstate;
        case constants.MESSAGE_EDIT_SUCCESS:
            newstate.isFetching = false;
            newstate.error = {};
            return newstate;
        case constants.MESSAGE_EDIT_FAILURE:
            newstate.isFetching = false;
            newstate.error = action.errors;
            return newstate;

        case constants.VALIDATION_MESSAGE_ERROR:
            newstate.isFetching = false;
            newstate.error = action.errors;
            return newstate;
        case constants.CLEAR_MESSAGE_ERROR:
            newstate.isFetching = false;
            newstate.error = {};
            return newstate;
        default: return state || initialState.message;
    }
}

module.exports = messageReducer;



// WEBPACK FOOTER //
// ./src/common/modules/message-center/reducers/message.js